<app-wait-container class="height100p flex-col" [loading]="loading">
    @if (inited) {
        <sm-toolbar>
            <p-button icon="fas fa-check" [label]="app.t('general.forward')" [disabled]="isForwarding" (onClick)="forward()">
            </p-button>
            <p-button *ngIf="app.getEnvironment().developer" icon="fas fa-check" [label]="app.t('wfs.forwardSimulate')"
                (onClick)="forwardSimulate()" [disabled]="isForwarding"></p-button>
            <p-button *ngIf="workflowActivityDef.allowSaveButton || app.getEnvironment().developer" icon="fas fa-save" [label]="app.t('general.save')"  [disabled]="isForwarding" (onClick)="save()"></p-button>
            <p-button icon="fas fa-times" [label]="app.t('general.cancel')"  [disabled]="isForwarding" (onClick)="cancel()"></p-button>
        </sm-toolbar>
        <p-tabView class="flex-item-fill full-height" [class.hide-tabs]="!workflowDef.showTray && !app.getEnvironment().developer">
            <p-tabPanel [header]="app.t('wfs.workflow')">
                <sm-form class="overflow-x-clip" [form]="workflowForm != null ? workflowForm.form : null" [style.position]="'relative'" [fixedWidth]="formWidth" [fixedHeight]="formHeight">
                </sm-form>
            </p-tabPanel>
            <p-tabPanel *ngIf="workflowDef.showTray" [header]="app.t('wfs.documents')">
                <div class="flex-col height100p">
                    @if (fd) {
                        <p-message class="flex-item-fixed" severity="warn" [text]="app.t('wfs.families.Reisekosten.trayInfo')" [escape]=false></p-message>    
                    }
                    @if (canAddDocuments) {
                        <sm-toolbar class="flex-item-fixed">
                            <p-button icon="fas fa-plus" [label]="app.t('wfs.attachDocument')" (onClick)="attachDocument()">
                            </p-button>
                        </sm-toolbar>
                    }
                    <div class="flex-item-fill flex-row-split">
                        <sm-table2 #documentsTableComponent class="width50p height100p" 
                            [data]="documentsTable" 
                            [allowRemoveRow]=true
                            [selection]="selectedDocument" 
                            [performRemoveTableRow]="_removeDocument" 
                            [removeRowWarningMessage]="this.app.t('wfs.removeDocument')" 
                            (onRowSelect)="selectDocument($event)"
                        >
                        </sm-table2>
                        <enaio-document-file-preview class="width50p height100p" [documentToken]="selectedDocument?.token">
                        </enaio-document-file-preview>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel *ngIf="app.getEnvironment().developer" [header]="app.t('general.developer')">
                <div *ngIf="workflowForm != null" class="height100p flex-col">
                    <sm-toolbar class="flex-item-fixed">
                        <button pButton icon="fas fa-redo" [label]="app.t('wfs.refreshDebugView')" (click)="refreshDebugView()">
                        </button>
                       <span class="mr-2">Event ausführen:</span>
                        @for (event of _Utils.getOwnPropertyNames(workflowForm.clientScriptFunctions); track event) {
                            <button pButton [label]="_Utils.stringRemovePrefix(event, 'clientScript')" (click)="runScript(event)">
                            </button>
                        }
                    </sm-toolbar>
                    <app-div-inner-html class="flex-item-fill" styleClass="monospace" [html]="debugViewString">                
                    </app-div-inner-html>
                 </div>
            </p-tabPanel>
        </p-tabView>
    }
</app-wait-container>
